import UserTable from 'components/tables/data/user/UserTable';
import DashboardLayout from 'layouts/dashboard/DashboardLayout';
import { useEffect, useState } from 'react';
import { useSearchParams } from 'react-router-dom';

/**
 * Page used to display a list of users.
 *
 */
export default function UsersPage() {
  const [searchParams, setSearchParams] = useSearchParams();

  const [initialFilters] = useState(() => {
    const filters: Record<string, any> = {};

    if (searchParams.has('organizationId')) {
      filters['organization.organizationId'] = {
        filterType: 'text',
        type: 'equals',
        filter: searchParams.get('organizationId'),
      };
    }

    return filters;
  });

  useEffect(() => {
    setSearchParams((params) => {
      params.delete('organizationId');
      return params;
    });
  }, []);

  return (
    <DashboardLayout breadcrumbs={[{ title: 'Používatelia' }]} height="screen">
      <UserTable initialFilters={initialFilters} />
    </DashboardLayout>
  );
}
